/**
 * API endpoint paths
 * Centralized API endpoint definitions
 */
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: "/api/auth/login",
    REGISTER: "/api/auth/register",
    LOGOUT: "/api/auth/logout",
    REFRESH: "/api/auth/refresh",
    CHANGE_PASSWORD: "/api/auth/change-password",
  },

  // Customers
  CUSTOMERS: {
    BASE: "/api/customers",
    LIST: "/api/customers/list",
    GET: "/api/customers/get",
    CREATE: "/api/customers/create",
    UPDATE: "/api/customers/update",
    DELETE: "/api/customers/delete",
    UPLOAD_IMAGE: "/api/customers/upload-image",
    DELETE_IMAGE: "/api/customers/delete-image",
    BY_ID: (id) => `/api/customers/${id}`,
    ASSIGN_CONSULTANT: (id) => `/api/customers/${id}/assign-consultant`,
  },

  // Customer Services
  CUSTOMER_SERVICES: {
    BASE: "/api/customer-services",
    BY_ID: (id) => `/api/customer-services/${id}`,
    BY_CUSTOMER: (customerId) =>
      `/api/customer-services/customer/${customerId}`,
    BY_SERVICE: (serviceId) =>
      `/api/customer-services/service/${serviceId}/customers`,
    CHECK_ASSIGNED: "/api/customer-services/check-assigned",
    ASSIGN: "/api/customer-services/assign",
    BULK_ASSIGN: "/api/customer-services/bulk-assign",
    UPDATE_VERSION: "/api/customer-services/update-version",
    REMOVE: "/api/customer-services/remove",
  },

  // Services
  SERVICES: {
    CATALOG: "/api/ServiceCatalog",
    SCRAPER: "/api/scraper",
  },

  // Scraper
  SCRAPER: {
    TRIGGER: "/api/scraper/trigger",
    STATUS: "/api/scraper/status",
    HISTORY: "/api/scraper/history",
  },
};
